'use strict';

var debounce = require('lodash/debounce');
var base = require('base/search/search');

/**
 * Update the Show More / Show Less buttons
 *
 */
function expandCollapse() {
    $('.refinements .card-header').not('.sterile').on('click', function () {
        var $this = $(this);
        var $parent = $this.parent();
        var $refinements = $('.refinements');

        $refinements.find('.card').not($parent).removeClass('active');
        $refinements.find('.card-header').not($this).addClass('collapsed');
        $refinements.find('.card-body').not($parent.find('.card-body')).removeClass('show');

        $parent.toggleClass('active');
        $this.toggleClass('collapsed');
        $parent.find('.card-body').toggleClass('show');
    });
}
/**
 * Update Product image src of new products
 *
 */
function loadImages() {
    const images = document.querySelectorAll('.tile-image:not(.lazyLoaded)');

    images.forEach(image => {
        const src = image.getAttribute('data-src');
        image.src = src;
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

module.exports = $.extend(base, {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.search-results').on('click', 'button.filter-results', function () {
            $('body').addClass('fixed');
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },
    closeRefinements: function () {
        // Refinements close button
        $('.search-results').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('body').removeClass('fixed');
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },
    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $(window).on('resize', debounce(function () {
                var $refinements = $('.refinements');

                $('.refinement-bar, .modal-background').hide();
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);

                $refinements.find('.card').removeClass('active');
                $refinements.find('.card-header').addClass('collapsed');
                $refinements.find('.card-body').removeClass('show');
            }, 500));
        });
    },
    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.search-results').on('click', '.refinements li button, .secondary-bar button.reset, .filter-value button, .swatch-filter button, .refinements-selected button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).data('href');
        });
    },
    sort: function () {
        // Handle sort order menu selection
        $('.search-results').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    showMoreLess: function () {
        expandCollapse();
        $(document).on('click', function (e) {
            var container = $('.card-header:not(.sterile)');
            // If the target of the click isn't the container
            if (!container.is(e.target) && container.parent().has(e.target).length === 0) {
                var $refinements = $('.refinements');

                $refinements.find('.card').removeClass('active');
                $refinements.find('.card-header').addClass('collapsed');
                $refinements.find('.card-body').removeClass('show');
            }
        });
    },
    showMore: function () {
        // Show more products
        $('.container-fluid').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                    loadImages();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
});
